"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const TeamMember_1 = __importDefault(require("../TeamMember"));
const TeamMemberList_module_scss_1 = __importDefault(require("./TeamMemberList.module.scss"));
function TeamMemberList({ teamMembers, loader, deleteHandler, ownerMode = false }) {
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    return (react_1.default.createElement("table", { className: TeamMemberList_module_scss_1.default.userTable },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", null, t('info.first-name')),
                react_1.default.createElement("th", null, t('info.last-name')),
                react_1.default.createElement("th", null, t('info.email')),
                react_1.default.createElement("th", null, t('info.status')))),
        teamMembers.map((user) => (react_1.default.createElement(TeamMember_1.default, { showControls: ownerMode, deleteHandler: deleteHandler, key: user.id, user: user }))),
        loader));
}
TeamMemberList.defaultProps = {
    loader: undefined,
    deleteHandler: undefined,
};
exports.default = TeamMemberList;
